import { FC } from 'react';
import { DrawerContainer } from './Drawer.styles';
import { DrawerProps } from './types';

export const Drawer: FC<DrawerProps> = ({ children, className }) => (
  <DrawerContainer className={className}>{children}</DrawerContainer>
);
